<template><article><h1>Marks</h1>
<h3 id="when-marks-is-true"><a class="header-anchor" href="#when-marks-is-true" aria-hidden="true">#</a> When <code v-pre>marks</code> is <code v-pre>true</code></h3>
<p><example :value="example1"></example></p>
<h3 id="when-the-type-of-marks-is-object"><a class="header-anchor" href="#when-the-type-of-marks-is-object" aria-hidden="true">#</a> When the type of <code v-pre>marks</code> is <code v-pre>Object</code></h3>
<p><example :value="example2"></example></p>
<h3 id="when-the-type-of-marks-is-array"><a class="header-anchor" href="#when-the-type-of-marks-is-array" aria-hidden="true">#</a> When the type of <code v-pre>marks</code> is <code v-pre>Array</code></h3>
<p><example :value="example3"></example></p>
<h3 id="when-the-type-of-marks-is-function"><a class="header-anchor" href="#when-the-type-of-marks-is-function" aria-hidden="true">#</a> When the type of <code v-pre>marks</code> is <code v-pre>Function</code></h3>
<p><example :value="example4"></example></p>
<h3 id="use-with-included"><a class="header-anchor" href="#use-with-included" aria-hidden="true">#</a> Use with <code v-pre>included</code></h3>
<p><example :value="example5"></example></p>
<h3 id="use-hidelabel-to-hide-the-label"><a class="header-anchor" href="#use-hidelabel-to-hide-the-label" aria-hidden="true">#</a> Use <code v-pre>hideLabel</code> to hide the label</h3>
<p><example :value="example6"></example></p>
</article></template>

<script>
  import examples from '@/examples/marks.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>